import { hideSearch } from "./search";
import { ResetMainMenu } from "./menu";

/**
 * Megamenu
 * Use: import { initMegaMenu } from "./components/megamenu";
 */

export function initMegaMenu() {
	MegaMenuSetUp();

	const MegaMenuToggle = $(".mega-menu-expander"),
		MainMenuItem = $(".menu-item-top-level"),
		MainMenuItemChildMega = $(".child-is-mega"),
		MegaMenuItem = $(".mega-menu-item"),
		PreviewItem = $(".mega-menu-preview-item"),
		PreviewTitle = $(".prev-title"),
		PreviewSubTitle = $(".prev-subtitle"),
		PreviewImage = $(".prev-image"),
		NoImage = $(".preview-no-image"),
		PreviewContent = $(".prev-content__top-content"),
		PrevFlavor = $(".prev-content__flavor"),
		MegaBackdrop = $(".mega-backdrop");

	// Toggle mega menu on click
	// --------------------------------------------------------------
	MegaMenuToggle.on("click", function () {
		const $this = $(this).parent(),
			MegaMenu = $this.find(".megamenu"),
			MegaMenuSub = MegaMenu.find(".mega-submenu--0 .mega-menu-item, .mega-child-submenu .mega-menu-item");

		// console.log(MegaMenuSub);
		$(this).toggleClass("open");

		if ($this.attr("aria-expanded") === "false") {
			$this.attr("aria-expanded", true).addClass("expanded");

			// Display Mega menu as Grid
			MegaMenu.css("display", "grid");
			MegaMenu.addClass("is-open");

			// Hide first level sub-menu-items if mega menu is second level
			// --------------------------------------------------
			// if ($this.hasClass("mega-menu-parent--1")) {
			//  $this.parent().addClass("sub-mega-comp");
			// }

			// Toggle first item in sub menu on initial open
			MegaMenuSub.each(function (i) {
				// console.log("Kommer vi ens hit!?");
				// Code to execute if the element has the specified class
				const $OpenFirstItem = $(this).parent().find("li.current-menu-parent").length === 0 ? true : false;

				// console.log($OpenFirstItem);
				MegaMenuSub.each(function (i) {
					if ($OpenFirstItem === true && i > 0) {
						return false;
					}

					const $item = $(this),
						itemID = $item.data("menu-item-id");

					$item.attr("aria-expanded", true).addClass("expanded");
					$('[data-submenu-id="' + itemID + '"]').css("display", "grid");

					// Reset all other Menu items and hide their sub menus
					MegaMenuItem.not($item).each(function () {
						let otherItemID = $(this).data("menu-item-id");
						$(this).attr("aria-expanded", false).removeClass("expanded");
						$('[data-submenu-id="' + otherItemID + '"]').css("display", "none");
					});

					ResetMegaPreview();
				});
			});
		} else {
			$this.attr("aria-expanded", false).removeClass("expanded");

			// Remove open class
			MegaMenu.removeClass("is-open");
			MegaMenu.css("display", "none");
			ResetMegaMenu();
		}

		// Reset Preview
		// --------------------------------------------------
		ResetMegaPreview();

		// Hide Search Bar
		// --------------------------------------------------
		hideSearch();

		// Hide Active Menu Item if mega menu is in top level
		// --------------------------------------------------
		if (!$this.hasClass("mega-menu-parent--1")) {
			ResetMainMenu();
		}

		// Show current submenu when opening mega menu again
		// --------------------------------------------------
		$this.find("ul.mega-submenu > li").each(function () {
			if ($(this).hasClass("current-menu-parent")) {
				const $item = $(this),
					itemID = $item.data("menu-item-id");
				$item.attr("aria-expanded", true).addClass("expanded");

				$('[data-submenu-id="' + itemID + '"]').css("display", "grid");
			} else {
				$(this).attr("aria-expanded", false);
				$(this).removeClass("expanded");
			}
		});

		var $OpenFirstItem = $this.find("ul.mega-child-submenu--1 > li.current-menu-parent").length;

		$this.find("ul.mega-child-submenu--1 > li").each(function () {
			if ($(this).hasClass("current-menu-parent")) {
				const $item = $(this),
					itemID = $item.data("menu-item-id");

				$item.attr("aria-expanded", true).addClass("expanded");

				$('[data-submenu-id="' + itemID + '"]').css("display", "grid");

				return false;
			} else {
				$(this).attr("aria-expanded", false);
				$(this).removeClass("expanded");

				$(".mega-child-submenu[data-submenu-id]").css("display", "none");
				console.log($OpenFirstItem);
				if ($OpenFirstItem === 0) {
					if ($(this).hasClass("mega-menu-item")) {
						var $FirstIDToOpen = $(this).data("menu-item-id");
						console.log($FirstIDToOpen);
						$('[data-submenu-id="' + $FirstIDToOpen + '"]').css("display", "grid");
						return false;
					}
				}
			}
		});
	});

	// Toggle Second level menu on click
	// --------------------------------------------------------------
	MegaMenuItem.on("click", function () {
		const $this = $(this),
			itemID = $this.data("menu-item-id");

		// Clicked Item is not Open
		if ($this.attr("aria-expanded") === "false") {
			$this.attr("aria-expanded", true).addClass("expanded");
			$('[data-submenu-id="' + itemID + '"]').css("display", "grid");

			// Clicked Item is Open, So do nothing
		} else if ($this.attr("aria-expanded") === "true") {
			//$this.attr("aria-expanded", false).removeClass("expanded");
			//$('[data-submenu-id="' + itemID + '"]').css("display", "none");
		}

		// Reset all other Menu items
		// And hide their sub menus
		MegaMenuItem.not($this).each(function () {
			let itemID = $(this).data("menu-item-id");
			$(this).attr("aria-expanded", false).removeClass("expanded");
			$('[data-submenu-id="' + itemID + '"]').css("display", "none");
		});

		// Reset Preview
		// --------------------------------------------------
		ResetMegaPreview();
	});

	// Hide and reset Mega Menu
	// --------------------------------------------------------------
	$(document).on("keydown", function (evt) {
		if (evt.keyCode == 27) {
			ResetMegaMenu();
		}
	});

	MegaBackdrop.on("click", function () {
		ResetMegaMenu();
		ResetMainMenu();
	});

	// Display Preview Data on Mouse Over
	// --------------------------------------------------------------
	PreviewItem.on("mouseover", function () {
		const $this = $(this),
			PreviewData = $this.data("preview"),
			TitleData = PreviewData["title"],
			ImageData = PreviewData["image"],
			CategoryData = PreviewData["category"],
			ContentData = PreviewData["content"],
			SizeData = PreviewData["size"],
			UnitData = PreviewData["unit"],
			FlavorData = PreviewData["flavor"],
			RoastingData = PreviewData["roasting"],
			FullnesstData = PreviewData["fullness"],
			AcidityData = PreviewData["acidity"];
		let SubTitle = "";

		if (SizeData && UnitData) {
			SubTitle = `${CategoryData}, ${SizeData}${UnitData}`;
		} else {
			SubTitle = CategoryData;
		}

		// Reset flavor profile an active values
		PrevFlavor.hide();
		$("[data-prev-roasting]").removeClass("active");
		$("[data-prev-fullness]").removeClass("active");
		$("[data-prev-acidity]").removeClass("active");

		// Populate Preview Data
		PreviewTitle.html(TitleData);
		PreviewSubTitle.html(SubTitle);
		PreviewContent.html(ContentData);

		// Display image or placeholder
		if (ImageData !== "") {
			NoImage.hide();
			PreviewImage.show();
			PreviewImage.attr("src", ImageData);
		} else {
			PreviewImage.hide();
			NoImage.show();
		}

		// Display flavor profile if all data is set
		// Activate correct value
		if (RoastingData["0"] !== "0" && FullnesstData["0"] !== "0" && AcidityData["0"] !== "0") {
			if (RoastingData && FullnesstData && AcidityData) {
				$('[data-prev-roasting="' + RoastingData + '"]').addClass("active");
				$('[data-prev-fullness="' + FullnesstData + '"]').addClass("active");
				$('[data-prev-acidity="' + AcidityData + '"]').addClass("active");
				PrevFlavor.show();
			}
		}
	});
}

// Set up mega menu
// --------------------------------------------------------------
function MegaMenuSetUp() {
	// Move sub-menus to same level as category level
	const megaMenuProducts = $(".mega-submenu--1, .mega-child-submenu--2");
	megaMenuProducts.each(function () {
		let $this = $(this);
		$this.parent().parent().parent().append($this);
	});
}

// Reset Mega Menu
// --------------------------------------------------------------
export function ResetMegaMenu() {
	const MegaMenuToggle = $(".mega-menu-expander"),
		MegaMenuParentItem = MegaMenuToggle.parent(),
		MegaMenu = $(".megamenu"),
		MegaSubLevel1 = $(".mega-menu-item"),
		MegaSubLevel2 = $(".mega-submenu--1"),
		MegaChildSubLevel2 = $(".mega-child-submenu--2");

	// Reset main menu item
	// --------------------------------------------------
	MegaMenuParentItem.each(function () {
		if ($(this).attr("aria-expanded") === "true") {
			$(this).attr("aria-expanded", false).removeClass("expanded");
		}
	});

	MegaMenuToggle.each(function () {
		$(this).removeClass("open");

		// Reset sub-mega-menu parent open state compensation
		if ($(this).parent().parent().hasClass("sub-mega-comp")) {
			$(this).parent().parent().removeClass("sub-mega-comp");
		}
	});

	// Reset Mega Menu
	// --------------------------------------------------
	MegaMenu.removeClass("is-open");
	MegaMenu.css("display", "none");

	// Reset Sub menu level 1
	// --------------------------------------------------
	MegaSubLevel1.each(function () {
		$(this).attr("aria-expanded", false).removeClass("expanded");
	});

	// Reset Sub menu level 2
	// --------------------------------------------------
	MegaSubLevel2.css("display", "none");
	MegaChildSubLevel2.css("display", "none");

	// Reset Preview
	// --------------------------------------------------
	ResetMegaPreview();
}

// Reset Preview
// --------------------------------------------------------------
function ResetMegaPreview() {
	const PreviewTitle = $(".prev-title"),
		PreviewSubTitle = $(".prev-subtitle"),
		PreviewImage = $(".prev-image"),
		PreviewContent = $(".prev-content__top-content"),
		PrevFlavor = $(".prev-content__flavor"),
		NoImage = $(".preview-no-image");

	PreviewTitle.html("");
	PreviewSubTitle.html("");
	PreviewImage.attr("src", "");
	NoImage.hide();
	PreviewContent.html("");
	PrevFlavor.hide();
	$("[data-prev-roasting]").removeClass("active");
	$("[data-prev-fullness]").removeClass("active");
	$("[data-prev-acidity]").removeClass("active");
}
